export const renderQuillDelta = (deltaString) => {
  let delta;
  try {
    delta = JSON.parse(deltaString);
  } catch (err) {
    return <p>{deltaString}</p>; // fallback if JSON parse fails
  }

  return delta?.map((op, index) => {
    if (typeof op.insert === "string") {
      return <span key={index}>{op.insert}</span>;
    }

    if (op.insert.image) {
      // Display image URL instead of actual image
      return (
        <a
          key={index}
          href={op.insert.image}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#007bff", textDecoration: "underline" }}
        >
          {op.insert.image}
        </a>
      );
    }

    return null;
  });
};
